import QuestionPaths from "./players/question/QuestionPaths";
import ActivityPaths from "./players/activity/ActivityPaths";
import ItemPaths from "./players/item/ItemPaths";

export const LIB_PREFIX = "com.playpower";
export const LAUNCHER_VERSION = "latest";

export enum ContentTypes {
    QUESTION = "questionTypes",
    ITEM = "itemTypes",
    ACTIVITY = "activityTypes",
    SEQUENCE = "sequencETypes",
    SCORECARD = "scorecardTypes",
}

export const PATH_PREFIX = (process.env.NODE_ENV === "development") ? "src/" : `${LIB_PREFIX}/`;

export abstract class IQuestionType {
    public abstract loadResources(paths: QuestionPaths): Promise<{}>;
    public abstract play(): Promise<{}>;
}

export abstract class IActivityType {
    public abstract loadResources(paths: ActivityPaths): Promise<{}>;
    public abstract play(): Promise<{}>;
}
export abstract class IItemType {
    public abstract loadResources(paths: ItemPaths): Promise<{}>;
    public abstract play(): Promise<{}>;
}
export abstract class IScorecardType {
    public abstract loadResources(): Promise<{}>;
    public abstract play(): Promise<{}>;
}

export abstract class ISequenceType {
    public abstract start(): void;
    public abstract setItemResult(result: any, itemIndex?: number): void;
    public abstract getAllResult(): any;
    public abstract getNextItem(): any;
    public abstract getSequencerProps(): any;
}

export interface IManifest {
    modules: string[];
}
